import { OrgAdminConstants } from '../../../_constants';

const initialState = { toggleAnalysisLoading: true, data: '', error: false };

export function toggleAnalysisReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_TOGGLE_ANALYSIS:
            return {
                toggleAnalysisLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_TOGGLE_ANALYSIS:
            return {
                toggleAnalysisLoading: false,
                data: action.getOrgUser,
                error: false
            };
        case OrgAdminConstants.TOGGLE_ANALYSIS_ERROR:
            return {
                toggleAnalysisLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/toggleAnalysis.reducer.js